import { Head } from '@inertiajs/react';
import { Button } from '@/components/ui/button';

const Torner = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Head title="torneremovia" />
      <main className="relative min-h-screen overflow-hidden px-6 py-10">
        <div
          className="absolute inset-0 bg-linear-to-b from-primary/10 via-background to-background"
          aria-hidden="true"
        />
        <div
          className="absolute right-[-10%] top-[-15%] h-96 w-96 rounded-full bg-primary/25 blur-3xl"
          aria-hidden="true"
        />
        <div
          className="torner-ring absolute left-1/2 top-1/2 w-11/12 max-w-md -translate-x-1/2 -translate-y-1/2 aspect-square rounded-full border border-border/70"
          aria-hidden="true"
        />
        <div
          className="torner-ring torner-ring-delay absolute left-1/2 top-1/2 w-9/12 max-w-sm -translate-x-1/2 -translate-y-1/2 aspect-square rounded-full border border-border/40"
          aria-hidden="true"
        />
        <div className="relative mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center gap-6 text-center">
          <h1>torneremovia</h1>
          <p className="text-muted-foreground">Si torna, ma non indietro: si torna verso di se.</p>
          <Button asChild>
            <a href="https://www.emovia.com">Scopri Emovia</a>
          </Button>
          <p className="text-muted-foreground">Niente giri a vuoto. Solo rientro lucido.</p>
          <div className="rounded-full border border-border px-4 py-1">
            <p className="text-muted-foreground">Loop utili solo se portano chiarezza</p>
          </div>
        </div>
      </main>
      <style>{`
        .torner-ring {
          animation: torner-ring 3.2s ease-in-out infinite;
        }
        .torner-ring-delay {
          animation-delay: 0.6s;
        }
        @keyframes torner-ring {
          0% { opacity: 0.25; transform: translate(-50%, -50%) scale(0.95); }
          50% { opacity: 0.6; transform: translate(-50%, -50%) scale(1.03); }
          100% { opacity: 0.25; transform: translate(-50%, -50%) scale(0.95); }
        }
        @media (prefers-reduced-motion: reduce) {
          .torner-ring { animation: none; }
        }
      `}</style>
    </div>
  );
};

export default Torner;
